import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-content">
        <p>© 2025 RA Engineering Services. All rights reserved.</p>
      </div>
    </div>
  );
};

export default Footer;
